import './App.css';

function App() {

  const logo = 'NewEra_logo.png';

  return (
    <div className="min-h-screen bg-white text-black flex flex-col items-center justify-center px-4 text-center">
      <div className="mb-6">
        <img src={logo} className="w-100 h-24 mb-4" alt="NewEra Logo" />
        <p className="text-xl md:text-2xl mt-4 text-gray-400">
          Our site is currently under construction
        </p>
      </div>
      <div className="w-32 h-32 border-4 border-red-600 rounded-full flex items-center justify-center animate-pulse mb-8">
        <span className="text-lg font-bold">⚔️🥋</span>
      </div>
      <p className="mt-8 text-sm text-gray-600">
        © {new Date().getFullYear()} NewEra Combat Sport System. All rights reserved.
      </p>
    </div>
  );
}

export default App;
